import { render, staticRenderFns } from "./folders-table-row.vue?vue&type=template&id=65a2133a&scoped=true"
import script from "./folders-table-row.vue?vue&type=script&lang=js"
export * from "./folders-table-row.vue?vue&type=script&lang=js"
import style0 from "./folders-table-row.vue?vue&type=style&index=0&id=65a2133a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2133a",
  null
  
)

export default component.exports